import React, {FC} from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import {ActivationData} from '../../../../../../types';
import useStyles from './ActivationsItem.styles';
import {getLocale} from '@epic-core/common/dist';
import {compactNumberFormatter} from '@epic-visualizations/charts';
import MyTop10GamesPanelTrend from '../../../../../sidebar/my-top-10-games/MyTop10GamesPanelTrend';
import styled from 'styled-components';
import {getTrend} from '../../../../../../../server/handlers/controllers/fortnite-game/utils';
import ListTooltip from './ListTooltip';
import ColorSwatchDot from '../../components/ColorSwatchDot';
import TooltipPopover from './TooltipPopover';

export const TOOLTIP_WIDTH = 340;

const Rank = styled.div<{
    rank: number;
    color: string;
}>`
    width: ${p => p.rank}%;
    height: 13px;
    margin-top: 4px;

    background-color: ${p => p.color};
`;

export interface ActivationsItemProps extends ActivationData {
    rank: number;
    colorIndex: number;
}

const ActivationsItem: FC<ActivationsItemProps> = ({
    name,
    description,
    previousActivations,
    activations,
    rank,
    colorIndex,
    ...rest
}: ActivationsItemProps) => {
    const style = useStyles();
    const formatNumber = compactNumberFormatter(getLocale());
    const activationsFormatted = formatNumber(activations);
    const trend = getTrend(previousActivations, activations, 0);

    const TooltipContent = (
        <ListTooltip
            name={name}
            description={description}
            trend={trend}
            colorIndex={colorIndex}
            formattedActivations={activationsFormatted}
            {...rest}
        />
    );

    return (
        <TooltipPopover title={TooltipContent}>
            <Box className={style.activationItem}>
                <Box className={style.triggerName}>
                    <Typography className={`${style.triggerNameText} ${style.triggerNameEllipsis}`}>
                        {name}
                    </Typography>
                    <Typography
                        className={`${style.triggerNameDescription} ${style.triggerNameEllipsis}`}>
                        {description}
                    </Typography>
                </Box>
                <Box className={style.activationData}>
                    <Box className={style.activationsNumber}>{activationsFormatted}</Box>
                    <MyTop10GamesPanelTrend value={trend} />
                </Box>
                <Box className={style.activationsBar}>
                    <Rank rank={rank} color="#2D74DA" />
                </Box>
                <Box className={style.activationsColorMarker}>
                    <ColorSwatchDot height="0.8625rem" width="0.8625rem" colorIndex={colorIndex} />
                </Box>
            </Box>
        </TooltipPopover>
    );
};

export default ActivationsItem;
